<template>
  <div class="BindCardManage">
    <div class="list list_margin">
      <List class="List_style" left="||类电子账户">
        <div class="List_copy">
          <div>{{ cardNum }}</div>
          <div class="List_copy_btn" @click="onSee">查看</div>
        </div>
      </List>
    </div>

    <div class="lineBox">
      <div class="line"></div>
    </div>
    <div class="list">
      <List left="开户银行" right="浦发银行" />
    </div>

    <div class="bindCardRecord">
      <div>
        <div class="cardTiedRecord">已绑卡记录</div>
        <div class="bankCardBox">
          <div v-for="(e, index) in bankCard" :key="index" class="bankCard">
            <div class="bankCardInfo">
              <div class="bankCardInleft">
                <div class="bindCardInfo">
                  <div class="bindCardName">{{ e.text }}</div>
                </div>
              </div>
              <div
                class="unbundling"
                @click="
                  () => {
                    handleUnbundling(e)
                  }
                "
              >
                解绑
              </div>
            </div>
            <div class="bankNumBox">
              <div class="bankNum">**** **** **** {{ e.binding_acct_no }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bindCardBox">
        <van-button
          :class="{ bindCard: !disabled, disabled: disabled }"
          :disabled="disabled"
          type="info"
          @click="handleBindCard"
        >
          <van-icon name="plus" />
          绑定银行卡
        </van-button>
      </div>
      <div class="bindCardNum">
        最多可以绑定3张银行卡，剩余可绑定{{ surplus }}张
      </div>
    </div>
    <div class="fundAccount">
      <van-button
        @click="handleFundAccount"
        class="fundAccountprimary"
        plain
        hairline
        type="primary"
        >返回资金账户</van-button
      >
    </div>
    <UnbundCard
      :bindingAcctNo="bindingAcctNo"
      @monitorForm="monitorForm"
      :custMobile="custMobile"
      @getAccountList="getAccountList"
      :bankName="bankName"
      v-model="vanPopupShow"
    ></UnbundCard>
    <self-popup v-model="ShowPopupContent"></self-popup>
    <div class="loadingBox" v-if="IsloadingBox">
      <Loading accountFont="加载中..." color="#fff" type="spinner"></Loading>
    </div>
  </div>
</template>
<script>
import { formatNum } from '@/utils';
import List from '@/components/List.vue';
import { mapState, mapMutations } from 'vuex';
import Loading from '@/components/Loading.vue';
import { Toast } from 'vant';
import UnbundCard from './UnbundCard.vue';

export default {
  name: 'BindCardManage',
  data() {
    return {
      cardNum: '',
      bankName: '',
      bankCard: [],
      vanPopupShow: false,
      bindingAcctNo: '',
      custMobile: '',
      ShowPopupContent: '',
      IsloadingBox: false,
    };
  },
  components: {
    List,
    UnbundCard,
    Loading,
  },
  computed: {
    ...mapState({
      capitalAccount(val) {
        return val.capitalAccount;
      },
    }),
    disabled() {
      const CONUT = 3;
      return this.bankCard.length >= CONUT;
    },
    surplus() {
      const TOTAL = 3;
      const STANDARD = 0;
      const LENGTH = this.bankCard.length;
      const result = TOTAL - LENGTH;
      return result > STANDARD ? result : STANDARD;
    },
    bankNum() {
      return formatNum(`${this.cardNum}`);
    },
  },
  mounted() {
    // 一类卡号
    this.getBalance();
    // 绑定银行卡号
    this.getAccountList();
    this.getInformation();
  },

  methods: {
    ...mapMutations('capitalAccount', ['updateState']),
    onSee() {
      this.$api.PublicPage.getSuccessfulLink({
        orderId: this.capitalAccount.orderId,
      }).then((res) => {
        console.log(res, '==res');
        if (res.success) {
          window.location.href = res.data.successful_link;
        } else {
          Toast(res.returnMessage);
        }
      });
    },
    getBalance() {
      const ORDERID = this.capitalAccount.orderId;
      this.$api.CommonForms.getBalance({
        orderId: ORDERID,
      }).then((res) => {
        if (res.success) {
          // eslint-disable-next-line camelcase
          const { card_num } = res.data;
          // eslint-disable-next-line camelcase
          this.cardNum = card_num;
          this.updateState({
            card_num,
          });
        }
      });
    },

    getAccountList() {
      this.IsloadingBox = true;
      const ORDERID = this.capitalAccount.orderId;
      this.$api.CommonForms.getAccountList({
        orderId: ORDERID,
      })
        .then((res) => {
          if (res.success) {
            this.bankCard = [];
            res.data.forEach((e) => {
              this.bankCard.push({
                text: e.bank_name,
                binding_acct_no: e.binding_acct_no,
                value: e.binding_card_id,
              });
            });
          } else {
            this.ShowPopupContent = res.returnMessage;
          }
          this.IsloadingBox = false;
        })
        .catch(() => {
          this.IsloadingBox = false;
          this.ShowPopupContent = '网络异常，请稍后再试！';
        });
    },

    handleUnbundling(e) {
      this.updateState({
        bindingCardId: e.value,
      });
      this.bindingAcctNo = e.binding_acct_no;
      this.vanPopupShow = true;
      this.bankName = e.text;
      this.getInformation();
    },

    monitorForm(val) {
      this.custMobile = val.custMobile;
    },

    handleFundAccount() {
      this.$router.push(
        `/supermarket/v2/Capitalaccount?orderId=${this.capitalAccount.orderId}`,
      );
    },

    handleBindCard() {
      this.$router.push('/supermarket/v2/BindCard');
    },

    getInformation() {
      const ORDERID = this.capitalAccount.orderId;
      this.$api.CommonForms.getInformation(ORDERID).then(
        (e) => {
          if (e.success) {
            this.custMobile = e.data.legalPhone;
          } else {
            this.ShowPopupContent = e.returnMessage;
          }
        },
      );
    },

  },
};
</script>

<style scoped>
.BindCardManage {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.list {
  background: #fff;
}
.List_copy {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  color: #495060;
}
.List_copy_btn {
  margin-left: 8px;
  color: #ff6538;
}
.line {
  height: 1px;
  background: #eee;
  margin: 0 16px;
}
.lineBox {
  width: 100%;
  background: #fff;
}
.cardTiedRecord {
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #1c2438;
  text-align: left;
  margin: 13px 15px 12px 15px;
}
.bankCardBox {
  padding: 0 16px;
}
.bankCard {
  display: flex;
  flex-direction: column;
  background: #f56040;
  border-radius: 4px;
  color: #fff;
  padding: 12px;
  margin-bottom: 16px;
}
.bankCardInfo {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.bindCardInfo {
  display: flex;
  justify-content: center;
  align-items: center;
}
.bankCardInleft {
  display: flex;
}
.bankNumBox {
  display: flex;
  flex-direction: row;
  margin-top: 12px;
}
.closEyes {
  margin-left: 16px;
}
.bankNum {
  opacity: 0.8;
  font-family: PingFangSC-Medium;
  font-size: 15px;
}
.bindCardImg {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.bindCardRecord {
  margin-top: 8px;
}
.fundAccountprimary {
  color: orangered;
  border: orangered;
  background: #f8f8f9;
  font-family: PingFangSC-Regular;
  font-size: 17px;
  color: #ff6538;
  letter-spacing: 0;
  border-radius: 4px;
  width: 100%;
}
.fundAccount {
  padding: 0 16px;
  margin-top: 12px;
}
.bindCardBox {
  font-family: PingFangSC-Regular;
  color: #ffffff;
  background: #fff;
  padding: 0 16px;
}
.disabled {
  background: #474749;
  font-size: 17px;
  border: 1px solid #474749;
  border-radius: 4px;
  width: 100%;
}
.bindCard {
  background-image: linear-gradient(180deg, #f5514a 2%, #f5683c 99%);
  border: none;
  font-size: 17px;
  border-radius: 4px;
  width: 100%;
}
.bindCardNum {
  text-align: left;
  font-family: PingFangSC-Regular;
  font-size: 13px;
  background: #fff;
  color: #a1aab6;
  padding: 8px 16px 16px 16px;
}
.unbundling {
  width: 50px;
  height: 20px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bindCardName {
  font-family: PingFangSC-Medium;
  font-size: 15px;
}
.bindCardbranch {
  opacity: 0.7;
  font-family: PingFangSC-Regular;
  font-size: 12px;
}
.BindCardManage >>> .van-button__text {
  display: flex;
  justify-content: center;
  align-items: center;
}
.van-icon-plus {
  font-size: 15px;
  font-weight: bold;
  margin-right: 6px;
  margin-bottom: 2px;
}
.loadingBox {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.BindCardManage >>> .Input {
  display: flex;
  flex-direction: column;
}
.BindCardManage >>> .van-cell--center {
  text-align: left;
  align-items: left !important;
}
.BindCardManage >>> .van-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.BindCardManage >>> .van-cell__value {
  width: 100%;
  margin-top: 16px;
}
.BindCardManage >>> .van-field__body > input {
  width: 100%;
}
.BindCardManage >>> .input_box {
  margin-top: 16px;
}
.BindCardManage >>> .van-field__body {
  width: 100%;
}
.BindCardManage >>> #buttonStyle {
  top: 0;
}
</style>
